/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import AddUserComponent from '../components/AddUserComponent'
import PropTypes from 'prop-types'
import { Growl } from 'primereact/growl'
import { userActions, roleActions } from '../_actions'
import { messageConstants } from '../_constants'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router'
import { getLoader } from '../_common/utils'


function AddUserContainer({ getUserById, userEntry, isGetAllError, isRoleLoading, updateUser, addUser, addUserMessage, roleList, getRoleList, updateUserMessage, clearAllMessages, isLoading }) {
  const growl = useRef()
  const [loader, setLoader] = useState(isLoading)
  const history = useHistory()
  const { id } = useParams()
  useEffect(() => {
    if (roleList.length < 1 && !isGetAllError && !isRoleLoading) {
      getRoleList()
    }
    if (id > 0 && !isLoading && !userEntry) {
      setLoader(true)
      getUserById(id)
      clearAllMessages()
      setTimeout(function () { setLoader(false) }, 2000)
      clearAllMessages()
    }

    if (addUserMessage === 'success') {
      setLoader(true)
      growl.current.show({ severity: 'success', summary: '', detail: 'User Added Successfully', life: 500 })
      setTimeout(function () { setLoader(false); history.push('/dashboard/user-list'); clearAllMessages() }, 3000)
    }
    if (updateUserMessage === 'success') {
      setLoader(true)
      growl.current.show({ severity: 'success', summary: '', detail: 'User Updated Successfully' })
      setTimeout(function () { setLoader(false); history.push('/dashboard/user-list'); clearAllMessages() }, 3000)
    }
    else if (addUserMessage === 'emailaddress-exist') {
      setLoader(true)
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Email Address already exists' })
      setTimeout(function () { setLoader(false); clearAllMessages() }, 1000)     
    }
  }, [addUserMessage, updateUserMessage])

  return (
    <div className="p-grid pageWrapper">
      {loader ? getLoader() : ''}
      <Growl ref={growl} />
      <AddUserComponent
        addUser={addUser}
        getUserById={getUserById}
        userEntry={userEntry}
        updateUser={updateUser}
        roleList={roleList}
        getRoleList={getRoleList}
      />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    userEntry: state.users.userEntry ? state.users.userEntry : null,
    roleList: state.role.roleList ? state.role.roleList : [],
    isLoading: state.users.isLoading,
    isRoleLoading: state.role.isRoleLoading,
    isGetAllError: state.role.isGetAllError,
    addUserMessage: state.users.addUserMessage,
    updateUserMessage: state.users.updateUserMessage,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (user) => dispatch(userActions.addUser(user)),
    getRoleList: () => dispatch(roleActions.getRoleList()),
    getUserById: (id) => dispatch(userActions.getUserById(id, true)),
    updateUser: (user, id) => dispatch(userActions.updateUser(user, id)),
    clearAllMessages: () => dispatch(userActions.clearAllMessages())
  }
}
AddUserContainer.propTypes = {
  addUser: PropTypes.func,
  getUserById: PropTypes.func,
  userEntry: PropTypes.object,
  isLoading: PropTypes.bool,
  updateUser: PropTypes.func,
  addUserMessage: PropTypes.string,
  updateUserMessage: PropTypes.string,
  clearAllMessages: PropTypes.func,
  roleList: PropTypes.array,
  getRoleList: PropTypes.func,
  isGetAllError: PropTypes.bool,
  isRoleLoading: PropTypes.bool
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUserContainer)
